import template from './template-export-new.html';
import TemplateExportNewController from './template-export-new.controller';

export default {
	path:        '/template-export/new',
	title:       'common.workspace',
	template,
	controller: TemplateExportNewController,
};
